import { render, staticRenderFns } from "./ReportMaterialsImageBtn.vue?vue&type=template&id=73dc85a6&"
import script from "./ReportMaterialsImageBtn.vue?vue&type=script&lang=js&"
export * from "./ReportMaterialsImageBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip}, component.options.components || {})
